import { render, staticRenderFns } from "./changePassFirst.vue?vue&type=template&id=2f78e7ba&"
import script from "./changePassFirst.vue?vue&type=script&lang=js&"
export * from "./changePassFirst.vue?vue&type=script&lang=js&"
import style0 from "./changePassFirst.vue?vue&type=style&index=0&id=2f78e7ba&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports